import axios from 'axios';
import * as types from '../constants/ActionTypes';
import { trackPage } from '../../lib/analytics-helper';

function setChatBotLoaded() {
  return { type: types.SET_CHAT_BOT_LOADED };
}

function setChatBotError() {
  return { type: types.SET_CHAT_BOT_ERROR };
}

export default function chatBotEligibleCheck() {
  return (dispatch) => {
    axios.get('/smarthelp/chat-bot-eligibility').then((response) => {
      if (response && response.data && response.data.chatBotInfo && response.data.chatBotInfo.chatEnabled) {
        setTimeout(() => {
          trackPage({ id: 'chatBot' });
          dispatch(setChatBotLoaded());
        // eslint-disable-next-line no-undef
          nodeChat.show('chatBot', 'c2cip');
        }, 200);
      }
    }).catch(() => {
      dispatch(setChatBotError());
    });
  };
}

